/**
 * The FileSaver allows to save browser generated files to
 * the local computer without using a proxy service.
 *
 * This class supports the latest version of the following browsers:
 *
 * Microsoft Internet Explorer 11
 * Microsoft Edge
 * Google Chrome
 * Mozilla Firefox
 * MacOS Safari
 * iOS Safari
 * Chrome for Android
 * SAP Fiori Client
 */

/**
 * This function saves the provided Blob to the local file system.
 * The parameter name is optional and depending on the browser it
 * is not ensured that the filename can be applied. Google Chrome,
 * Mozilla Firefox, Internet Explorer and Microsoft Edge will
 * apply the filename correctly.
 *
 * @param {Blob} blob - Binary large object of the file that should be saved to the filesystem
 * @param {string} [name] - Filename of the file including the file extension
 */
function saveFile(blob, name) {
	var link, downloadSupported, fnSave;

	/* Ignore other formats than Blob */
	if (!(blob instanceof Blob)) {
		return;
	}

	link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
	downloadSupported = 'download' in link;

	/* Try ObjectURL Chrome, Firefox, Opera, Android, Safari (Desktop ab 10.1) */
	if (downloadSupported) {
		fnSave = function(data, fileName) {
			link.download = fileName;
			link.href = URL.createObjectURL(data);
			link.dispatchEvent(new MouseEvent('click'));
		};
	}

	/* In case of iOS Safari, MacOS Safari */
	if (typeof fnSave === 'undefined') {
		fnSave = function(data) {
			var reader = new FileReader();

			reader.onloadend = function() {
				var opened, url;

				url = reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
				opened = window.open(url, '_blank');

				if (!opened) {
					window.location.href = url;
				}
			};
			reader.readAsDataURL(blob);
		};
	}

	/*
	 * IE/Edge implementation
	 *
	 * Microsoft Edge also supports the download attribute but ignores the value of the attribute.
	 * This is why we override it with the navigator.msSaveOrOpenBlob function in case of MS Edge.
	 */
	if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) {
		fnSave = function(data, fileName) {
			window.navigator.msSaveOrOpenBlob(data, fileName);
		};
	}

	/* Save file to device */
	fnSave(blob, name);
}

module.exports = { saveFile: saveFile };


//////////////////
// WEBPACK FOOTER
// ./client/src/filesaver/FileSaver.js
// module id = 39
// module chunks = 1